import { createTheme, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    background: 'rgba(255, 255, 255, 0.3)',
    zIndex: 99999,
  },
  badge: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    left: '40%',
    width: 'auto',
    flexDirection: 'row',
    backgroundColor: '#323349',
    marginTop: '20px',
    height: 'auto',
    minHeight: '70px',
    zIndex: 99999,
  },
  loader: { margin: '17px' },
  success: {
    color: '#FFFFFF !important',
    width: '30px',
    height: '30px',
    margin: '8px',
  },
  text: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    color: '#FFFFFF !important',
    marginRight: '12px',
  },
}));

export const theme = createTheme({
  overrides: {
    MuiCircularProgress: {
      colorPrimary: {
        color: 'white',
        size: '40',
      },
    },
  },
});
